import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "../context/AuthContext";
import { BookHeart, Heart, Sparkles } from "lucide-react";

export default function Login() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "rian@kencankita.id", password: "mochi123", personA: "", personB: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      if (mode === "login") {
        await login(form.email, form.password);
      } else {
        await register({
          email: form.email,
          password: form.password,
          personA: form.personA || "Kamu",
          personB: form.personB || "Pasangan",
          coupleName: `${form.personA || "Kamu"} & ${form.personB || "Pasangan"}`,
        });
      }
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Gagal masuk. Coba lagi.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen bg-[#faf8f5] md:grid-cols-2">
      {/* visual side */}
      <div className="relative hidden overflow-hidden md:block">
        <img
          src="/assets/destinations/atap-cerita.png"
          alt="Kencan di Atap Cerita"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#3a1e22]/85 via-[#3a1e22]/30 to-transparent" />
        <div className="absolute bottom-0 p-10 text-white">
          <div className="mb-3 flex items-center gap-2 text-[13px] font-semibold uppercase tracking-wider text-white/80">
            <Sparkles className="h-4 w-4" /> Untuk kalian berdua
          </div>
          <h2 className="text-3xl font-extrabold leading-tight">
            Temukan tempat kencan,<br />rawat Mochi bersama.
          </h2>
          <p className="mt-3 max-w-sm text-[14px] text-white/80">
            Jelajahi destinasi kencan pilihan, kumpulkan poin dari setiap kencan, dan besarkan peliharaan virtual kalian.
          </p>
        </div>
      </div>

      {/* form side */}
      <div className="flex items-center justify-center px-5 py-12">
        <div className="w-full max-w-sm kk-reveal">
          <div className="mb-8 flex items-center gap-2 text-[24px] font-extrabold tracking-tight">
            <span className="grid h-9 w-9 place-items-center rounded-xl kk-coral-gradient text-white">
              <BookHeart className="h-5 w-5" />
            </span>
            Kencan<span className="-ml-2 text-[#ff5a5f]">Kita</span>
          </div>

          <h1 className="text-2xl font-extrabold">{mode === "login" ? "Selamat datang kembali" : "Buat akun pasangan"}</h1>
          <p className="mb-6 mt-1 text-[14px] text-[#8a8278]">
            {mode === "login" ? "Masuk untuk lanjutkan cerita kalian." : "Mulai perjalanan kencan kalian bersama Mochi."}
          </p>

          <form onSubmit={submit} className="space-y-3.5">
            {mode === "register" && (
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="mb-1.5 block text-[12px] font-semibold text-[#8f7c7c]">Nama kamu</label>
                  <input value={form.personA} onChange={set("personA")} placeholder="Rian"
                    data-testid="register-persona"
                    className="w-full rounded-xl border border-[#e8dfd7] bg-white px-3.5 py-3 text-[14px] outline-none focus:border-[#ff5a5f]" />
                </div>
                <div>
                  <label className="mb-1.5 block text-[12px] font-semibold text-[#8f7c7c]">Nama pasangan</label>
                  <input value={form.personB} onChange={set("personB")} placeholder="Maya"
                    data-testid="register-personb"
                    className="w-full rounded-xl border border-[#e8dfd7] bg-white px-3.5 py-3 text-[14px] outline-none focus:border-[#ff5a5f]" />
                </div>
              </div>
            )}
            <div>
              <label className="mb-1.5 block text-[12px] font-semibold text-[#8f7c7c]">Email</label>
              <input type="email" required value={form.email} onChange={set("email")}
                data-testid="login-email"
                className="w-full rounded-xl border border-[#e8dfd7] bg-white px-3.5 py-3 text-[14px] outline-none focus:border-[#ff5a5f]" />
            </div>
            <div>
              <label className="mb-1.5 block text-[12px] font-semibold text-[#8f7c7c]">Kata sandi</label>
              <input type="password" required minLength={6} value={form.password} onChange={set("password")}
                data-testid="login-password"
                className="w-full rounded-xl border border-[#e8dfd7] bg-white px-3.5 py-3 text-[14px] outline-none focus:border-[#ff5a5f]" />
            </div>

            {error && <p className="text-[13px] font-medium text-[#c9363b]" data-testid="auth-error">{error}</p>}

            <button
              type="submit"
              disabled={busy}
              data-testid="login-submit"
              className="flex w-full items-center justify-center gap-2 rounded-full kk-coral-gradient py-3.5 text-[15px] font-bold text-white transition-transform active:scale-[0.98] disabled:opacity-60"
            >
              <Heart className="h-4 w-4 fill-white" />
              {busy ? "Memproses…" : mode === "login" ? "Masuk" : "Daftar"}
            </button>
          </form>

          <p className="mt-6 text-center text-[13px] text-[#8a8278]">
            {mode === "login" ? "Belum punya akun?" : "Sudah punya akun?"}{" "}
            <button
              onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(""); }}
              data-testid="toggle-auth-mode"
              className="font-bold text-[#ff5a5f]"
            >
              {mode === "login" ? "Daftar" : "Masuk"}
            </button>
          </p>

          {mode === "login" && (
            <p className="mt-4 rounded-xl bg-[#f5f1eb] px-3 py-2.5 text-center text-[12px] text-[#8a8278]">
              Akun demo sudah terisi: <b>rian@kencankita.id</b> / <b>mochi123</b>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
